export const CLEAN_SP_COMPANY_REGISTRATION_DATA = 'CLEAN_SP_COMPANY_REGISTRATION_DATA';
export const CHANGE_SP_COMPANY_REGISTRATION_CURRENT_STEP = 'CHANGE_SP_COMPANY_REGISTRATION_CURRENT_STEP';
export const CHANGE_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT = 'CHANGE_SP_COMPANY_REGISTRATION_FILLED_STEPS_COUNT';
export const CHANGE_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT = 'CHANGE_SP_COMPANY_REGISTRATION_VISITED_STEPS_COUNT';
export const CHANGE_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN = 'CHANGE_SP_COMPANY_REGISTRATION_RECAPTCHA_TOKEN';

export const CHANGE_SP_COMPANY_SERVICES_INFO = 'CHANGE_SP_COMPANY_SERVICES_INFO';
export const REGISTER_SP_COMPANY = 'REGISTER_SP_COMPANY';

export const REGISTRATION_SP_COMPANY_FINISHED = 'REGISTRATION_SP_COMPANY_FINISHED';
export const REQUEST_EMAIL_VERIFICATION_SP_COMPANY = 'REQUEST_EMAIL_VERIFICATION_SP_COMPANY';
export const VERIFY_EMAIL_SP_COMPANY = 'VERIFY_EMAIL_SP_COMPANY';
export const CHANGE_SP_COMPANY_AVATAR = 'CHANGE_SP_COMPANY_AVATAR';
export const CHANGE_SP_COMPANY_EMAIL_VERIFICATION_INFO = 'CHANGE_SP_COMPANY_EMAIL_VERIFICATION_INFO';

export const LOAD_SP_COMPANY_SERVICES = 'LOAD_SP_COMPANY_SERVICES';
export const LOAD_SP_COMPANY_CERTIFICATES = 'LOAD_SP_COMPANY_CERTIFICATES';
export const LOAD_SP_COMPANY_REGIONS = 'LOAD_SP_COMPANY_REGIONS';
export const LOAD_SP_COMPANY_EMPLOYEES_AMOUNT = 'LOAD_SP_COMPANY_EMPLOYEES_AMOUNT';

export const CHANGE_SP_COMPANY_MAIN_INFO = 'CHANGE_SP_COMPANY_MAIN_INFO';
export const CHANGE_SP_COMPANY_CERTIFICATIONS_INFO = 'CHANGE_SP_COMPANY_CERTIFICATIONS_INFO';
export const CHANGE_SP_COMPANY_RECOMMENDATION_INFO = 'CHANGE_SP_COMPANY_RECOMMENDATION_INFO';
export const CHANGE_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO = 'CHANGE_SP_COMPANY_SOCIAL_NETWORK_LINK_INFO';
export const CHANGE_SP_COMPANY_IP_ADDRESS_INFO = 'CHANGE_SP_FREELANCER_IP_ADDRESS_INFO';
export const LOAD_COMPANY_SUGGESTIONS_FOR_SP = 'LOAD_COMPANY_SUGGESTIONS_FOR_SP';
